import * as React from "react";
const TherapistMenu = ({ color = "#276AA6", ...props }) => (
  <svg
    width={19}
    height={16}
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.3335 5.08362H11.7502"
      stroke={color}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.6665 11.7501H6.33317"
      stroke={color}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.4165 11.7501H11.7498"
      stroke={color}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0002 9.69163V11.425C18.0002 14.35 17.2585 15.0833 14.3002 15.0833H5.0335C2.07516 15.0833 1.3335 14.35 1.3335 11.425V4.57496C1.3335 1.64996 2.07516 0.916626 5.0335 0.916626H11.7502"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3335 5.91663V0.916626L18.0002 2.58329"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3332 0.916626L14.6665 2.58329"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TherapistMenu;